import {Button as ChakraButton, ButtonProps} from '@chakra-ui/react'

export const Button = (props: ButtonProps) => {
  return <ChakraButton {...props}></ChakraButton>
}
export default Button
